import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { CheckCircle2, Clock, XCircle, Ticket } from 'lucide-react';

const STATUS = {
  valid: { label: 'VALID', cls: 'bg-emerald-100 text-emerald-700 border-emerald-300', icon: CheckCircle2 },
  admitted: { label: 'REDEEMED', cls: 'bg-blue-100 text-blue-700 border-blue-300', icon: CheckCircle2 },
  pending_payment: { label: 'PENDING PAYMENT', cls: 'bg-amber-100 text-amber-700 border-amber-300', icon: Clock },
  cancelled: { label: 'CANCELLED', cls: 'bg-red-100 text-red-700 border-red-300', icon: XCircle },
};

export const TicketCard = ({ ticket }) => {
  if (!ticket) return null;
  const s = STATUS[ticket.status] || STATUS.valid;
  const Icon = s.icon;
  const qrValue = `${window.location.origin}/eticket/ticket/${ticket.qr_token}`;
  return (
    <div className="max-w-sm mx-auto rounded-2xl overflow-hidden shadow-2xl bg-white" data-testid="ticket-card">
      <div className="bg-gradient-to-br from-[#0C2159] to-[#13317a] p-5 text-white">
        <div className="flex items-center gap-2">
          <Ticket className="w-5 h-5 text-cyan-300" />
          <span className="text-xs font-semibold tracking-widest uppercase text-cyan-300">StayMii E-Ticket</span>
        </div>
        <h2 className="text-xl font-bold mt-2" data-testid="ticket-attraction">{ticket.company_name}</h2>
      </div>
      <div className="p-6 flex flex-col items-center">
        <div className={`px-3 py-1 rounded-full border text-xs font-bold mb-4 flex items-center gap-1 ${s.cls}`} data-testid="ticket-status">
          <Icon className="w-3.5 h-3.5" /> {s.label}
        </div>
        <div className="p-3 bg-white rounded-xl border border-slate-200">
          <QRCodeCanvas value={qrValue} size={180} fgColor="#0C2159" level="H" data-testid="ticket-qr" />
        </div>
        <p className="mt-3 font-mono text-sm font-bold text-slate-800" data-testid="ticket-number">{ticket.ticket_number}</p>
        <div className="w-full mt-4 space-y-2 text-sm">
          <Row k="Guest" v={ticket.holder_name} />
          <Row k="Ticket type" v={ticket.rate_name || 'Admission'} />
          {ticket.visit_date && <Row k="Visit date" v={fmtDate(ticket.visit_date)} />}
          {ticket.purchase_date && <Row k="Purchase date" v={fmtDate(ticket.purchase_date)} />}
          <Row k="Paid" v={`${(ticket.currency || 'MYR').toUpperCase()} ${Number(ticket.amount).toFixed(2)}`} />
          {ticket.admitted_at && <Row k="Redeemed" v={new Date(ticket.admitted_at).toLocaleString()} />}
        </div>
        <p className="text-[11px] text-slate-400 mt-4 text-center">Present this QR code at the entrance for admission.</p>
        {ticket.visit_date && (
          <p className="text-xs font-semibold text-[#0C2159] mt-1 text-center" data-testid="ticket-valid-note">
            Valid only on {fmtDate(ticket.visit_date)} — not before or after.
          </p>
        )}
      </div>
    </div>
  );
};

const fmtDate = (val) => {
  if (!val) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(val);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`; // dd-mm-yyyy from yyyy-mm-dd / ISO
  const d = new Date(val);
  if (isNaN(d)) return val;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${d.getFullYear()}`;
};

const Row = ({ k, v }) => (
  <div className="flex justify-between border-b border-dashed border-slate-200 pb-1">
    <span className="text-slate-500">{k}</span>
    <span className="font-medium text-slate-800">{v}</span>
  </div>
);

export default TicketCard;
